<template>
  <el-tabs v-model="activeName">
    <el-tab-pane
      v-for="(item, index) of underLeaseOrderTabsList"
      :label="item.label"
      :name="item.name"
      :key="index"
    >
      <component
        v-if="activeName === item.name"
        :is="item.components"
        :childActiveName="childActiveName"
      />
    </el-tab-pane>
  </el-tabs>
</template>
<script>
// 配置
// eslint-disable-next-line import/no-cycle
import config from './config'

export default {
  data() {
    const {
      // tab列表
      c_underLeaseOrderTabsList,
    } = config.call(this)
    return {
      c_underLeaseOrderTabsList,
      underLeaseOrderTabsList: [],
      activeName: 'personal',
      childActiveName: '',
    }
  },
  activated() {
    this.getRouteQuery()
  },
  mounted() {
    this.init()
    this.getRouteQuery()
  },
  methods: {
    getRouteQuery() {
      const { activeName, childActiveName } = this.$route.query
      if (activeName) {
        this.activeName = activeName
      }
      if (childActiveName) {
        this.childActiveName = childActiveName
      }
    },
    init() {
      // tabs权限判断
      this.underLeaseOrderTabsList = this.c_underLeaseOrderTabsList.filter((item) => {
        return this.judgePermission(item.resourcesKey)
      })
      // 默认展示第一个有权限的tabs
      this.activeName = this.underLeaseOrderTabsList[0] && this.underLeaseOrderTabsList[0].name
    },
  },
}
</script>
